export default __webpack_public_path__ + "static/media/gol_logo.538fbdc5.png";